import { Modal } from '@77sol-ui/molecules'
import styled from 'styled-components'
import { fontFamily } from '@77sol-ui/tokens'

export const StyledModalWrapper = styled(Modal.Content)`
  * {
    font-family: ${fontFamily.sans.toString()};
  }
`
